import { makeStyles } from "@mui/styles";

export const useContainerServices = makeStyles({
    container: {
        padding: 0,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        margin: "0",
        gap: "10px",
        height: "calc(100% - 172px)",
        "@media screen and (max-width: 1280px)": {
            height: "calc(100% - 146px)",
        },
        "@media screen and (min-width: 1281px) and (max-width: 1919px)": {
            height: "calc(100% - 160px)",
        },
    },
    containerMotel: {
        backgroundColor: "#fff",
        padding: "16px",
        boxShadow: "0px 6px 18px 0px #0000000F",
        borderRadius: "5px",
        height: "100%",
        overflow: "auto",
        width: "59.5%",
        "@media screen and (max-width: 1280px)": {
            width: "49.5%",
        },
    },
    containerCardServices: {
        display: "flex",
        gap: "20px",
        marginBottom: "30px",
        flexWrap: "wrap",
    },
    title: {
        fontSize: "15px",
        color: "#192A3E",
        fontWeight: "700",
        marginBottom: "12px",
    },
    chips: {
        display: "flex",
        gap: "10px",
        marginBottom: "30px",
        flexWrap: "wrap",
        width: "100%",
    },
    subNote: {
        color: "#979ea8",
        marginBottom: "30px",
    },

    containerListRoom: {
        backgroundColor: "#fff",
        boxShadow: "0px 6px 18px 0px #0000000F",
        borderRadius: "5px",
        height: "100%",
        overflow: "auto",
        width: "39.3%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "@media screen and (max-width: 1280px)": {
            width: "49.5%",
        },
    },
});
